import React, { useState } from "react";
import { Button, Message, Switch, Input } from "../../../BP2Components";
import { useDispatch, useSelector } from "react-redux";
import IntlMessages from "@util/IntlMessages";
import { SketchPicker } from "react-color";
import { v4 as uuidv4 } from "uuid";
import "./GlobalSettings.less";

import { useIntl } from "react-intl";
import {
   addWidgetInSheet,
   setWidgetInSheetParams,
   updateWidgetSettings,
} from "../../../../appRedux/actions/Actions";
const GlobalSettings = ({ value }) => {
   const dispatch = useDispatch();
   const intl = useIntl();
   const boards = useSelector(({ boards }) => boards);
   const [settings, setSettings] = useState({
      ...value,
   });

   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      dispatch(updateWidgetSettings(settings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };

   const handleChangeInput = (name) => (e) => {
      setSettings({ ...settings, [name]: +e.target.value });
   };

   const handleDefaultColor = () => {
      setSettings({ ...settings, backgroundColourHex: "#fff" });
   };
   const handleHideWidgetBackground = (value, name) => {
      setSettings(() => ({ ...settings, [name]: value }));
   };

   const [displayColorPicker, setDisplayColorPicker] = useState(false);
   const handleClose = () => {
      setDisplayColorPicker(false);
   };
   const handleClick = () => {
      setDisplayColorPicker(!displayColorPicker);
   };

   const handleChangeColor = (color) => {
      setSettings({ ...settings, backgroundColourHex: color.hex });
   };

   const copyWidget = () => {
      const currentSheetId = boards.sheet;
      const findSheetDetails = boards?.currentBoard?.sheets.find(
         (sheet) => sheet.id === currentSheetId,
      );

      const currentWidget = findSheetDetails?.widgets?.find((widget) => widget.id === value.id);
      const widgetCopy = {
         ...currentWidget,
         id: uuidv4(),
      };
      dispatch(addWidgetInSheet(widgetCopy));
      Message.success(intl.formatMessage({ id: "global.copySuccess" }, 3));
   };

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings padding-left-15">
               <div key="globalSettings" className="widget-settings__inner">
                  <label key="xsWidth" className="widget-settings__inner__label">
                     <IntlMessages id="settings.xsWidth" />:
                     <Input
                        type="number"
                        name="xsWidth"
                        onChange={handleChangeInput("xsWidth")}
                        min={1}
                        max={24}
                        defaultValue={value.xsWidth}
                     />
                  </label>
                  <label key="smWidth" className="widget-settings__inner__label">
                     <IntlMessages id="settings.smWidth" />:
                     <Input
                        type="number"
                        name="smWidth"
                        onChange={handleChangeInput("smWidth")}
                        min={1}
                        max={24}
                        defaultValue={value.smWidth}
                     />
                  </label>
                  <label key="mdWidth" className="widget-settings__inner__label">
                     <IntlMessages id="settings.mdWidth" />:
                     <Input
                        type="number"
                        name="mdWidth"
                        onChange={handleChangeInput("mdWidth")}
                        min={1}
                        max={24}
                        defaultValue={value.mdWidth}
                     />
                  </label>
                  <label className="widget-settings__inner__label" key="lgWidth">
                     <IntlMessages id="settings.lgWidth" />
                     <Input
                        type="number"
                        name="lgWidth"
                        onChange={handleChangeInput("lgWidth")}
                        min={1}
                        max={24}
                        defaultValue={value.lgWidth}
                     />
                  </label>
                  <label className="widget-settings__inner__label" key="xlWidth">
                     <IntlMessages id="settings.xlWidth" />:
                     <Input
                        type="number"
                        name="xlWidth"
                        onChange={handleChangeInput("xlWidth")}
                        min={1}
                        max={24}
                        defaultValue={value.xlWidth}
                     />
                  </label>
                  <label className="widget-settings__inner__label" key="priority">
                     <IntlMessages id="settings.priority" />:
                     <div>
                        <Input
                           type="number"
                           name="priority"
                           onChange={handleChangeInput("priority")}
                           min={1}
                           defaultValue={value.priority}
                           aria-describedby="priority-hint"
                        />
                        <span id="priority-hint" className="widget-settings__priority-hint">
                           <IntlMessages
                              id="settings.priorityHint"
                              defaultMessage="Pole ustala kolejność wyświetlania widgetu na widoku mobilnym. Niższa wartość = wyżej na liście."
                           />
                        </span>
                     </div>
                  </label>
                  <label className="widget-settings__inner__label" key="backgroundColourHex">
                     <IntlMessages id="settings.backgroundColour" />:
                     <div>
                        <Button
                           onClick={handleClick}
                           className="cp-color"
                           style={{
                              backgroundColor: settings.backgroundColourHex,
                           }}
                        >
                           <IntlMessages id="settings.clickToChangeColor" />
                        </Button>
                        <Button onClick={handleDefaultColor}>
                           <IntlMessages id="settings.setDefaultColor" />
                        </Button>
                     </div>
                     {displayColorPicker ? (
                        <div className="cp-popover">
                           <div className="cp-cover" onClick={handleClose} />
                           <SketchPicker
                              color={settings.backgroundColourHex}
                              onChange={handleChangeColor}
                           />
                        </div>
                     ) : null}
                  </label>
                  <label className="widget-settings__inner__label" key="hideWidgetBorder">
                     <IntlMessages id="settings.hideWidgetBorder" />:
                     <Switch
                        size="small"
                        checked={settings?.hideWidgetBorder}
                        onChange={(e) => handleHideWidgetBackground(e, "hideWidgetBorder")}
                     />
                  </label>
                  <p>ID: {value.id}</p>
               </div>
            </div>
            <Button
               key="copy"
               id="copy-widget-button"
               onClick={copyWidget}
               style={{
                  marginLeft: "70%",
                  marginRight: 10,
               }}
            >
               <IntlMessages id="settings.copyWidget" />
            </Button>
            <Button buttonType="primary" htmlType="submit">
               <IntlMessages id="global.preview" />
            </Button>
         </form>
      </>
   );
};

export default GlobalSettings;
